import ListarPrevisitas from '../components/EncuestaSSV/ListarPrevisitas.jsx';
import FormularioPrevisitas from '../components/EncuestaSSV/FormularioPrevisitas.jsx';
import InicioEncuesta from '../components/EncuestaSSV/InicioEncuesta.jsx';
import DatosBasicos from '../components/EncuestaSSV/DatosBasicos.jsx';
import SSVSalud from '../components/EncuestaSSV/SSVSalud.jsx';
import SSVEducacion from '../components/EncuestaSSV/SSVEducacion.jsx';
import SSVFuerzaTrabajo from '../components/EncuestaSSV/SSVFuerzaTrabajo.jsx';
import SSVOtrosIngresos from '../components/EncuestaSSV/SSVOtrosIngresos.jsx';
import SSVPerfilProductivo from '../components/EncuestaSSV/SSVPerfilProductivo.jsx';
import SSVAlimentacion from '../components/EncuestaSSV/SSVAlimentacion.jsx';
import SSVVivienda from '../components/EncuestaSSV/SSVVivienda.jsx';
import SSVReunificacion from '../components/EncuestaSSV/SSVReunificacion.jsx';
import Reportes from '../components/EncuestaSSV/Reportes.jsx';
import SSVConsultas from '../components/EncuestaSSV/SSVConsultas.jsx';


export const SsvRoutes = [
    { path: '/encuestassv/previsitas', element: <ListarPrevisitas /> },
    { path: '/encuestassv/formularioprevisita/:idPrevisita', element: <FormularioPrevisitas /> },
    { path: '/encuestassv/id/:idEncuesta', element: <InicioEncuesta /> },
    { path: '/encuestassv/datosbasicos/:idPersona/:idEncuesta', element: <DatosBasicos /> },
    { path: '/encuestassv/salud/:idPersona/:idEncuesta', element: <SSVSalud /> },
    { path: '/encuestassv/educacion/:idPersona/:idEncuesta', element: <SSVEducacion /> },
    { path: '/encuestassv/fuerzatrabajo/:idPersona/:idEncuesta', element: <SSVFuerzaTrabajo /> },
    { path: '/encuestassv/otrosingresos/:idPersona/:idEncuesta', element: <SSVOtrosIngresos /> },
    { path: '/encuestassv/perfilproductivo/:idPersona/:idEncuesta', element: <SSVPerfilProductivo /> },
    { path: '/encuestassv/alimentacion/:idEncuesta', element: <SSVAlimentacion /> },
    { path: '/encuestassv/vivienda/:idEncuesta', element: <SSVVivienda /> },
    { path: '/encuestassv/reunificacion/:idEncuesta', element: <SSVReunificacion /> },
    { path: '/encuestassv/reportes', element: <Reportes /> },
    { path: '/encuestassv/consultas', element: <SSVConsultas /> },

];
